import _ from 'lodash'
import {connect} from 'react-redux'

import {DetailsOverview} from './detailsoverview.component'


import userUtil from '../util/user.util'
import legUtil from '../util/leg.util'


const mapStateToProps = (state) => {
    let leg = legUtil.getActiveLeg(state)
	
    return {
	    user: userUtil.getCurrentUser(state),
	    hasAccommodation: !leg.get('accommodations').isEmpty(),
	    hasTravel: !legUtil.getTransportation(state, leg.getIn(['id'])).isEmpty(),
	    hasActivity: !leg.get('activities').isEmpty(),
	    transportation: legUtil.getTransportation(state, leg.getIn(['id'])),
	    isLunaTrip: state.getIn(['lunaTrip', 'isLunaTrip']),
    }
}

const mapDispatchToProps = (dispatch) => {
    return {

    }
}

const DetailsOverviewContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(DetailsOverview)

export default DetailsOverviewContainer
